import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Processes the one-time session_id from the URL fragment after Google auth, establishes the session,
// then returns the user to the scanner (where their in-progress report is restored from sessionStorage).
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = (location.hash || "").match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (sessionId) {
        try {
          const u = await exchangeSession(sessionId);
          setUser(u);
        } catch (e) {
          // fall through — user will land on the scanner unauthenticated
          console.warn("Session exchange failed; continuing unauthenticated.", e);
        }
      }
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
      navigate(window.location.pathname || "/", { replace: true });
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div data-testid="auth-callback" className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex items-center gap-3 text-foreground">
        <Loader2 className="h-5 w-5 animate-spin text-primary" />
        <span className="font-heading text-sm tracking-wide">Signing you in…</span>
      </div>
    </div>
  );
}
